module.exports = __webpack_public_path__ + "media/img/pages/profile/hslu ger 7-fec5b6a2f619dc72c4568d77870c977e.jpg";